import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Modal, Button } from "@/components";
import styles from "./SuccessCancelTournamentRequestModal.module.scss";
import successDeleteGameIcon from "@/assets/img/successDelete.svg";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

interface SuccessCancelTournamentRequestModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const SuccessCancelTournamentRequestModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessCancelTournamentRequestModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const handleClose = () => {
    closeModal();
    navigate("/padel/tournaments/applied");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Modal
      title="Заявка успешно отменена!"
      subTitle=""
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      firmBack
    >
      <div className={styles.content}>
        <img 
          src={successDeleteGameIcon} 
          alt="success cancel tournament request" 
          className={styles.image} 
        />
        {
          isMobile && (
            <div className={styles.mobileContent}>
              <span className={styles.mobileTitle}>
                Заявка успешно отменена
              </span>
            </div>
          )
        }
        <Button onClickFunc={handleClose} newStyles={styles.button}>
          Вернуться в "Вы присоединились"
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessCancelTournamentRequestModalComponent;
export const SuccessCancelTournamentRequestModal = SuccessCancelTournamentRequestModalComponent;
